import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ApiClient from "helpers/ApiClient";

const initialState: any = {
    requestList: [],
    loading: false
};

export const getRequestsList: any = createAsyncThunk<any>(
    "getRequestsList/setRequestsList",
    async (payload, thunkAPI) => {
        try {
            const response = await ApiClient.get(`${payload}`);  
            return response?.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

const requestsSlice = createSlice({
    name: "getRequestsList",
    initialState,
    reducers: {
        setRequestsList(state, action) {
            state.requestList = action.payload;
        },
    },

    extraReducers: {
        [getRequestsList.pending]: (state: any) => {
            state.loading = true
        },
        [getRequestsList.fulfilled]: (state: any, action: any) => {
            state.loading = false
            state.requestList = action.payload;
        },
        [getRequestsList.rejected]: (state: any) => {
            state.loading = false
        },
    },
});

export const { setRequestsList } = requestsSlice.actions;
export default requestsSlice;